.statusContainer {
    flex-direction: column;
    width: 100%;
}

.declinedContainer {
    width: 100%;
    justify-content: space-between;
}

.statusIcon {
    margin-top: 3rem;
    width: 16rem;
    display: flex;
    place-content: center;
}

.declinedIcon {
    display: flex;
    place-content: end;
    margin: 0;
    padding-top: 20px;
}

.statusHeader {
    color: var(--mantine-color-white);
    --text-fz: var(--mantine-font-size-lg);
    --text-lh: var(--mantine-line-height-lg);
    line-height: 130%;
}

.statusBodyText {
    color: var(--mantine-color-white);
    --text-fz: var(--mantine-font-size-sm);
    --text-lh: var(--mantine-line-height-sm);
    line-height: 130%;
}

.footerBox {
    width: 100%;
    height: var(--customer-panel-bottom-control-footer-height);
    position: absolute;
    bottom: 0;
    justify-content: flex-end;
    padding: 1rem;
}
